import {FC, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import {POST} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {useNavigate} from 'react-router-dom'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

const GradesHotelBookingCreate: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState('')
  const [variationValue, setVariationValue] = useState<number | null>(null)
  const [variationName, setVariationName] = useState('')
  const [status, setStatus] = useState<boolean>(true)
  const [list, setList] = useState<{name: string; value: number | null}[]>([])
  const [multiples, setMultiples] = useState<boolean>(false)
  const [description, setDescription] = useState<string>('')
  const [capacity, setCapacity] = useState<number>(1)

  const addList = () => {
    if (!variationName?.trim()) return
    setList((prev) => [...prev, {name: variationName.trim(), value: variationValue}])
    setVariationName('')
    setVariationValue(null)
  }

  const removeList = (variationPosition: number) => {
    setList((prev) => prev.filter((_, index) => variationPosition !== index))
  }

  const createGrid = async () => {
    try {
      if (!title || list.length === 0 || list.some((item) => !item?.name?.trim())) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos obrigatórios',
          text: "Preencha o 'Título', adicione itens e informe o 'Nome' de todos os itens.",
        })
        return
      }

      const payload = {
        title,
        content: {config: list},
        status,
        description,
        capacity,
        multiple: multiples,
      }

      setLoading(true)
      const gridRes = await POST('/grid-hotel-booking', payload)
      setLoading(false)

      if (gridRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: i18n.t(`gridHotelFeedback.grid_created`) as string,
          text: i18n.t(`gridHotelFeedback.grid_created_message`) as string,
        }).then(() => navigate('/hospitality/context/grid-hotel-booking'))
      } else {
        Swal.fire({
          icon: 'error',
          title: i18n.t(`gridHotelFeedback.error`) as string,
          text: gridRes?.message || (i18n.t(`gridHotelFeedback.error_create_message`) as string),
        })
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: i18n.t(`gridHotelFeedback.error`) as string,
        text: i18n.t(`gridHotelFeedback.error_create_message`) as string,
      })
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`gridHotelFeedback.create_service_grid`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`gridHotelFeedback.fill_information_create`)}
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='card-body border-bottom'>
                <div
                  className='d-flex justify-content-between align-items-center flex-wrap'
                  style={{columnGap: '1.5rem', rowGap: '0.8rem'}}
                >
                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{type: 'string'}}
                      // placeholder={
                      //   i18n.t(`gridHotelFeedback.service_grid_name_placeholder`) as string
                      // }
                      label={i18n.t(`gridHotelFeedback.title`) as string}
                      change={(value: string) => setTitle(value)}
                      value={title}
                      onlyLetters={true}
                      marginTop='0'
                      maxCaracteres={30}
                    />
                  </div>
                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{type: 'select'}}
                      value={status}
                      change={(val: boolean) => setStatus(val)}
                      label={i18n.t(`gridHotelFeedback.status`) as string}
                      options={[
                        {select: i18n.t(`gridHotelFeedback.general.active`) as string, value: true},
                        {
                          select: i18n.t(`gridHotelFeedback.general.inactive`) as string,
                          value: false,
                        },
                      ]}
                      marginTop='0'
                    />
                  </div>

                  <div className='w-100' />

                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{type: 'textarea'}}
                      value={description}
                      change={(val: string) => setDescription(val)}
                      label={i18n.t(`booking_hotel_services.field_description_label`) as string}
                      marginTop='0'
                      maxCaracteres={250}
                      rows={6}
                    />
                  </div>

                  <div className='w-100' />

                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{type: 'checkbox'}}
                      change={(val: boolean) => setMultiples(val)}
                      label={i18n.t(`booking_hotel_services.grid_multiple`) as string}
                      checked={multiples}
                      marginTop='0'
                    />
                  </div>

                  <div className='w-100' />

                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{type: 'number'}}
                      value={capacity}
                      change={(val: number) => {
                        if (val < 1) val = 1
                        setCapacity(val)
                      }}
                      label={i18n.t(`booking_hotel_services.grid_capacity`) as string}
                      toolTip={true}
                      toolTipIcon={'info-circle'}
                      toolTiptext={`${i18n.t(
                        `booking_hotel_services.day_config_info_line1`
                      )}\n${i18n.t(`booking_hotel_services.day_config_info_line2`)}`}
                      marginTop='0'
                    />
                  </div>
                </div>
                <hr className='my-4' />
                <div className='form-group mt-5'>
                  <label className='form-label fw-normal'>
                    {i18n.t(`gridHotelFeedback.service_list`)}
                  </label>
                  <div className='d-flex'>
                    <input
                      type='text'
                      className='form-control fw-normal'
                      placeholder={
                        i18n.t(`booking_hotel_services.grid_item_name_placeholder`) as string
                      }
                      value={variationName}
                      onChange={(event) => setVariationName(event.target.value)}
                    />
                    <div style={{minWidth: 160, marginLeft: 8}}>
                      <Input
                        inputAttr={{type: 'money'}}
                        currency='BRL'
                        locale='pt-BR'
                        placeholder={
                          i18n.t(`booking_hotel_services.grid_item_value_placeholder`) as string
                        }
                        value={variationValue ?? 0}
                        change={(val: number) => setVariationValue(val)}
                        marginTop='0'
                      />
                    </div>
                    <div className='input-group-append'>
                      <button
                        className='btn btn-success'
                        style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                        type='button'
                        onClick={addList}
                        disabled={!variationName?.trim()}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                {list.map((item, index) => (
                  <div className='form-group mt-5' key={index}>
                    <div className='d-flex'>
                      <input
                        type='text'
                        className='form-control fw-normal'
                        placeholder={
                          i18n.t(`booking_hotel_services.grid_item_name_placeholder`) as string
                        }
                        value={item.name}
                        onChange={(event) => {
                          const newList = [...list]
                          newList[index] = {...newList[index], name: event.target.value}
                          setList(newList)
                        }}
                      />
                      <div style={{minWidth: 160, marginLeft: 8}}>
                        <Input
                          inputAttr={{type: 'money'}}
                          currency='BRL'
                          locale='pt-BR'
                          placeholder={
                            i18n.t(`booking_hotel_services.grid_item_value_placeholder`) as string
                          }
                          value={item.value ?? 0}
                          change={(val: number) => {
                            const newList = [...list]
                            newList[index] = {...newList[index], value: val}
                            setList(newList)
                          }}
                          marginTop='0'
                        />
                      </div>
                      <div className='input-group-append'>
                        <button
                          className='btn btn-danger'
                          style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                          type='button'
                          onClick={() => removeList(index)}
                        >
                          -
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className='d-flex w-100'>
                <div className='col-6 d-flex justify-content-start'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{type: 'button'}}
                    click={() => navigate(-1)}
                    btnClass='fw-bolder m-9'
                  />
                </div>
                <div className='col-6  d-flex justify-content-end'>
                  <Button
                    text={i18n.t(`gridHotelFeedback.buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{type: 'button'}}
                    click={createGrid}
                    btnClass='fw-bolder m-9'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const GradesBookingCreate: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: i18n.t(`gridHotelFeedback.dashboard`) as string,
            path: 'dashboard',
            isActive: true,
          },
          {title: i18n.t(`gridHotelFeedback.service_grid`) as string, path: 'grid', isActive: true},
        ]}
      >
        {i18n.t(`gridHotelFeedback.service_grid`)}
      </PageTitle>
      <GradesHotelBookingCreate />
    </>
  )
}

export {GradesBookingCreate}
